import { SSO } from "src/components/auth/sso";

export default SSO;
